import {inject, injectable} from 'inversify';

import type {BaseDomainFactory} from '../Base/BaseDomain.factory';

import {ModelsRegistry} from '../../system/modelsRegistry/ModelsRegistry';
import {DateTimeModelFactory} from '../Date/DateTime.factory';
import {TENANT_NOT_FOUND} from './constants';
import {TenantModel} from './Tenant.model';

@injectable()
export class TenantFactory
  implements BaseDomainFactory<TenantModel, TenantModel.Props>
{
  constructor(
    @inject(DateTimeModelFactory)
    private readonly dateTimeModelFactory: DateTimeModelFactory,
    @inject(ModelsRegistry)
    private readonly modelsRegistry: ModelsRegistry,
  ) {}

  create(props: TenantModel.Props): TenantModel {
    return this.modelsRegistry.put(new TenantModel(props));
  }

  createEmpty(): TenantModel {
    return new TenantModel({
      clientId: '',
      created: this.dateTimeModelFactory.now(),
      id: 'tenant:not_found',
      notificationUrl: null,
      reporting: false,
      subtenants: [],
      templateFolder: '',
      title: TENANT_NOT_FOUND,
      updated: this.dateTimeModelFactory.now(),
    });
  }
}
